<mat-toolbar class="navbar-container">
  <div class="logo-container" routerLink="/">
    <img class="logo" src="assets/images/logos/logo-inline-inverse.png" alt="Logo" />
  </div>

  @if ($isDemo()) {
    <div class="demo-banner-container">
      <div class="demo-banner">
        <mat-icon>explore</mat-icon>
        <span>{{ 'navbar.demoModeBanner' | translate }}</span>
        <button mat-flat-button (click)="toggleDemo()">
          {{ 'navbar.deactivate' | translate }}
        </button>
      </div>
    </div>
  }

  <div class="right-side">
    @if ($isDemo()) {
      <div class="customer">{{ $selectedCustomer()?.companyName }}</div>
    } @else {
      @if ($user()?.customer) {
        <div class="customer">{{ $user()?.customer?.companyName }}</div>
      } @else {
        <dbx-entity-select
          [items]="$customers()"
          [loading]="$loading()"
          [completed]="$completed()"
          [selectedItem]="$selectedCustomer()"
          [displayFn]="customerDisplayFn"
          [placeholder]="'customers.searchPlaceholder'"
          (selected)="selectCustomer($event)"
          (search)="loadCustomers($event)"
          (loadMore)="loadMoreCustomers()"
        />
      }
    }

    <div class="language" [matMenuTriggerFor]="languageMenu">
      <div class="icon" [style.background-image]="LanguageEnum.icon($language())"></div>
      <div class="name">{{ LanguageEnum.name($language()) | translate }}</div>
    </div>

    <mat-menu #languageMenu="matMenu">
      @for (language of LanguageEnum.languages; track language) {
        <button mat-menu-item (click)="handleLanguageChange(language)" [class.active]="language === $language()">
          <div class="language-option">
            <div class="icon" [style.background-image]="LanguageEnum.icon(language)"></div>
            <span>{{ LanguageEnum.name(language) | translate }}</span>
          </div>
        </button>
      }
    </mat-menu>

    @if (authenticated()) {
      <div class="profile-logo" [matMenuTriggerFor]="profileMenu">
        {{ $user()?.firstName?.[0] }}
      </div>

      <mat-menu #profileMenu="matMenu" class="profile-menu">
        <div class="profile">
          <div class="logo">{{ $user()?.firstName?.[0] }}</div>
          <div class="profile-infos">
            <span class="name">{{ $user()?.firstName }} {{ $user()?.lastName }}</span>
            <span [matTooltip]="$user()?.email">{{ $user()?.email }}</span>
            <span>Org Admin</span>
            <span>v{{ version }}</span>
          </div>
        </div>

        <button class="item" mat-menu-item [matMenuTriggerFor]="settingsMenu">
          <mat-icon>settings</mat-icon>
          <span>{{ 'navbar.settings' | translate }}</span>
        </button>

        <button class="item" mat-menu-item [matMenuTriggerFor]="toolsMenu">
          <mat-icon>handyman</mat-icon>
          <span>{{ 'navbar.tools' | translate }}</span>
        </button>

        <a class="item" mat-menu-item href="mailto:{{ environment.branding.supportEmail }}">
          <mat-icon>contact_support</mat-icon>
          <span>{{ 'navbar.contactUs' | translate }}</span>
        </a>

        <button class="item" data-cy="logout-button" mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'navbar.logout' | translate }}</span>
        </button>
      </mat-menu>

      <mat-menu #settingsMenu="matMenu" class="tools-menu">
        <button mat-menu-item [routerLink]="[Paths.SETTINGS_PATH, Paths.PROFILE_PATH]">
          <mat-icon>account_circle</mat-icon>
          <span>{{ 'navbar.profile' | translate }}</span>
        </button>

        <button mat-menu-item (click)="toggleDemo()">
          <mat-icon>explore</mat-icon>
          <span>
            {{ ($isDemo() ? 'navbar.deactivateDemo' : 'navbar.activateDemo') | translate }}
          </span>
        </button>
      </mat-menu>
      <mat-menu #toolsMenu="matMenu" class="tools-menu">
        <button
          mat-menu-item
          [attr.data-cy]="'nav-' + Paths.INITIAL_SCAN_PATH"
          [routerLink]="[Paths.INITIAL_SCAN_PATH]"
        >
          <mat-icon>wifi_find</mat-icon>
          <span>{{ 'navbar.initialScan' | translate }}</span>
        </button>
      </mat-menu>
    }
  </div>
</mat-toolbar>
